import { motion } from "framer-motion";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Mail, Phone, MapPin } from "lucide-react";

const Impressum = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main>
        {/* Hero */}
        <section className="pt-32 pb-12 relative overflow-hidden">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_0%,hsl(210_100%_15%)_0%,transparent_60%)] opacity-60" />
          <div className="container mx-auto px-4 text-center relative">
            <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }}>
              <span className="text-primary font-sans text-sm tracking-[0.3em] uppercase mb-4 block">
                Rechtliches
              </span>
              <h1 className="font-display text-5xl md:text-6xl font-bold mb-4">
                Impres<span className="text-primary">sum</span>
              </h1>
            </motion.div>
          </div>
        </section>

        {/* Content */}
        <section className="pb-24">
          <div className="container mx-auto px-4">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="max-w-3xl mx-auto bg-card border border-border p-8 md:p-12 relative"
            >
            <div className="absolute -top-1 -left-1 w-4 h-4 border-t-2 border-l-2 border-primary" />
            <div className="absolute -top-1 -right-1 w-4 h-4 border-t-2 border-r-2 border-primary" />
            <div className="absolute -bottom-1 -left-1 w-4 h-4 border-b-2 border-l-2 border-primary" />
            <div className="absolute -bottom-1 -right-1 w-4 h-4 border-b-2 border-r-2 border-primary" />

            {/* Anbieter */}
            <div className="mb-10">
              <h2 className="font-display text-xl font-bold tracking-wider uppercase text-primary mb-4">
                Anbieter
              </h2>
              <div className="space-y-1 text-foreground">
                <p className="font-semibold">Giuseppe Romano</p>
                <p>Betontankstelle Giuseppe Romano</p>
                <div className="flex items-start gap-2 mt-3 text-muted-foreground">
                  <MapPin className="h-4 w-4 text-primary mt-1 flex-shrink-0" />
                  <span>
                    Primsaue 5
                    <br />
                    66809 Nalbach
                  </span>
                </div>
              </div>
            </div>

            <div className="border-t border-border my-8" />

            {/* Kontakt */}
            <div className="mb-10">
              <h2 className="font-display text-xl font-bold tracking-wider uppercase text-primary mb-4">
                Kontakt
              </h2>
              <ul className="space-y-3">
                <li className="flex items-center gap-3">
                  <Phone className="h-4 w-4 text-primary flex-shrink-0" />
                  <span className="text-muted-foreground">Telefon:</span>
                  <a
                    href="tel:+4915141315272"
                    className="text-foreground hover:text-primary transition-colors"
                  >
                    0151 – 41315272
                  </a>
                </li>
                <li className="flex items-center gap-3">
                  <Mail className="h-4 w-4 text-primary flex-shrink-0" />
                  <span className="text-muted-foreground">E-Mail:</span>
                  <a
                    href="mailto:info@beton2go-romano.de"
                    className="text-foreground hover:text-primary transition-colors"
                  >
                    info@beton2go-romano.de
                  </a>
                </li>
              </ul>
            </div>

            <div className="border-t border-border my-8" />

            {/* Streitbeilegung */}
            <div>
              <h2 className="font-display text-xl font-bold tracking-wider uppercase text-primary mb-4">
                Verbraucher­streit­beilegung / Universal­schlichtungs­stelle
              </h2>
              <p className="text-muted-foreground leading-relaxed">
                Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
                Verbraucherschlichtungsstelle teilzunehmen.
              </p>
            </div>

            <p className="mt-10 text-right text-xs text-muted-foreground">Quelle: eRecht24</p>
            </motion.div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default Impressum;
